import { HttpClient, HttpParams } from '@angular/common/http';
import { Injector } from '@angular/core';
import { SpinnerService } from '../../../core/services/spinner.service';
import { NotificationService } from 'app/core/services/notification.service';

export abstract class BaseService {
    protected rutaServidor = localStorage.getItem('rutaServidor');
    protected httpClient: HttpClient;
    protected spinnerService: SpinnerService;
    protected httpParams = new HttpParams();
    protected uri: string;
    protected notificationService: NotificationService;
    private injector: Injector;

    constructor(injector: Injector) {
        this.injector = injector;
        this.httpClient = this.injector.get(HttpClient);
        this.spinnerService = this.injector.get(SpinnerService);
        this.notificationService = this.injector.get(NotificationService); 
       //console.log('Instance BaseService');
       //console.log(this.httpClient);
    }

    convertToDate(body) {
        // debugger;
        if (body === null || body === undefined) {
            return body;
        }

        if (typeof body !== 'object') {
            return body;
        }

        const keys = Object.keys(body);
        for (const key of keys) {
            const value = body[key];
            if (this.isIso8601(value)) {
                body[key] = new Date(value);
            } else if (typeof value === 'object') {
                this.convertToDate(value);
            }
        }
    }

    isIso8601(value) {
        const iso8601 = /^\d{4}(-\d\d(-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?))$/;
        if (value === null || value === undefined) {
            return false;
        }

        return iso8601.test(value);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/_utils/services/base-service.ts